import {
  getCustomFields,
  getCustomFieldsColumns,
} from "@portal/api/custom-field";
import { invoiceFiltersAtom } from "@portal/store/Filters/Invoices/invoice-filter";
import { CustomFieldDataResponse } from "@portal/types/entities/custom-field";
import { ColumnTitle } from "@sinecycle/growcomponents";
import { useQuery } from "@tanstack/react-query";
import { useSetAtom } from "jotai";

function useCustomFieldsQuery() {
  const setFilters = useSetAtom(invoiceFiltersAtom);
  return useQuery({
    queryKey: ["custom-fields"],
    queryFn: () => getCustomFields(),
    retry: false,
    onSuccess(data) {
      const customerFiled = data
        .filter((f) => f.entity_type === "CUSTOMER")
        .map((f) => {
          return {
            key: f.id,
            label: <ColumnTitle hasSymbol>{f.display_name}</ColumnTitle>,
          };
        });
      const invoiceFiled = data
        .filter((f) => f.entity_type === "INVOICE")
        .map((f) => {
          return {
            key: f.id,
            label: <ColumnTitle hasSymbol>{f.display_name}</ColumnTitle>,
          };
        });

      setFilters((per) => {
        return {
          ...per,
          filterGroup: per.filterGroup.map((f) => {
            return f.key === "Customer"
              ? { ...f, children: customerFiled }
              : { ...f, children: invoiceFiled };
          }),
        };
      });
    },
  });
}

function useCustomFieldsColumns(
  onSuccessCallBack: (data: CustomFieldDataResponse[]) => void,
  enabled: boolean,
  handleErrorCallBack: () => void
) {
  return useQuery({
    queryKey: ["custom-fields-columns"],
    queryFn: () => getCustomFieldsColumns(),
    retry: false,
    enabled,
    onSuccess(data) {
      onSuccessCallBack(data);
    },
    onError(err) {
      handleErrorCallBack();
    },
  });
}

export { useCustomFieldsColumns, useCustomFieldsQuery };
